import styles from './flag-renderer.module.css';
import reactStringReplace from 'react-string-replace';

const CAUTION_REGEX = /!([^\s^!]*)\b!/;
const CAUTION_REGEX_ALLOW_SPACES = /!([^!]*)\b!/;
// eslint-disable-next-line no-useless-escape
const VEHICLE_REGEX = /\^([^\s^(\^)]*)\b\^/;
const VALID_VEHICLE_REGEX =
    /(^((A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])-)?[\w]{1,17}$)/i;

export function FlagRenderer({
    value,
    breakLines,
    allowSpaces,
}: {
    value?: string;
    breakLines?: boolean;
    allowSpaces?: boolean;
}): React.ReactElement {
    const valueWithCautionFlags = reactStringReplace(
        value,
        allowSpaces ? CAUTION_REGEX_ALLOW_SPACES : CAUTION_REGEX,
        (match, i) => (
            <div className={styles['caution-flag']} key={`caution-${i}`}>
                {match}
            </div>
        )
    );
    // ensure vehicle key is unique; reactStringReplace doesn't guarantee unique index for array input value
    let i = 0;
    const valueWithVehicleFlagsToo = reactStringReplace(
        valueWithCautionFlags,
        VEHICLE_REGEX,
        (match) =>
            VALID_VEHICLE_REGEX.exec(match) ? (
                <div className={styles['vehicle-flag']} key={`vehicle-${i++}`}>
                    {match}
                </div>
            ) : (
                match
            )
    );
    return <span style={breakLines ? {} : { whiteSpace: 'pre' }}>{valueWithVehicleFlagsToo}</span>;
}
